var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    _vm._b(
      {
        staticClass: "btn-grabar",
        attrs: { "data-testid": "GuardarButton", id: "btnGuardar" },
        on: { click: _vm.handleClick }
      },
      "v-btn",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    ),
    [
      _c(
        "span",
        { staticClass: "text" },
        [_vm._t("default", [_vm._v("Guardar")])],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }